import { actions as jobActions } from '@/api/jobs';
import { Button, Modal, ModalProps } from '@payaca/ambrosia';

import { Deal } from '@payaca/types/dealTypes';
import { Job } from '@payaca/types/jobTypesV2';
import { FC, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import useRemoveAccepted from '../../../api/mutations/proposals/useRemoveAccepted';

type Props = {
  removeAcceptedCallback: () => void;
  proposalId: Job['id'];
  projectVersion?: Deal['version'];
} & Omit<ModalProps, 'title'>;
const RemoveAcceptedModal: FC<Props> = (props) => {
  const { proposalId, removeAcceptedCallback, projectVersion, ...rest } = props;
  const dispatch = useDispatch();
  const [isUnacceptingJob, setIsUnacceptingJob] = useState(false);

  const { mutateAsync: removeAcceptedMutation } = useRemoveAccepted({
    onSuccess: () => {
      setIsUnacceptingJob(false);
      removeAcceptedCallback();
    },
  });

  const unacceptJob = useCallback(async () => {
    setIsUnacceptingJob(true);
    if (projectVersion && projectVersion > 1) {
      await removeAcceptedMutation({ proposalId: proposalId.toString() });
    } else {
      dispatch(
        jobActions.unacceptQuote(proposalId, () => {
          removeAcceptedCallback();
          setIsUnacceptingJob(false);
        })
      );
    }
    // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useCallback has missing dependencies: 'projectVersion', 'removeAcceptedMutation', and 'dispatch'
  }, [proposalId, removeAcceptedCallback]);

  return (
    <Modal {...rest} title="Remove acceptance">
      <Modal.Body>
        <p>
          {
            "This will remove the signature from the Proposal and can't be undone."
          }
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Actions>
          <Button
            onClick={unacceptJob}
            isProcessing={isUnacceptingJob}
            colour={'red'}
          >
            Remove signature
          </Button>
        </Modal.Footer.Actions>
      </Modal.Footer>
    </Modal>
  );
};
export default RemoveAcceptedModal;
